import React from "react";
import {Table, Input, Button, Icon, Row, Col, Tooltip, message, Modal, Dropdown, Menu, Divider,Switch} from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import NHTable from '../../common/NHTable';
import {hasAuth,getLoginUser} from "../../../utils/NHCore";
import {NHModal, NHConfirm} from '../../common/NHModal';
import NHContainerFrame from '../../common/NHContainerFrame';
import EditForm from './EditForm';
import ViewForm from './ViewForm';
import EditFlForm from './xxfbfl/EditFlForm';
import css from './index.css';
import NHUeditor from "../../common/NHUeditor";

const baseUrlPath = "/xxfb";


class XxfbTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},
            frameVisibleMap:{
                tableFlag:true,
                addFlag:false,
                updateFlag:false,
                showFlag:false,
                modelFlag:false,
                addAndEditFlFlag:false,
            },
            zt0:'',//状态名称
            zt1:'',//状态名称
            showDeleteBtn:false,//显示删除按钮
            getContent:undefined,//获取富文本编辑器的值
        };
    }

    //渲染前加载启用停用按钮参数
    componentDidMount() {
        NHFetch("/proData/selectDataList", "GET", {sign: 'dmk_xtgl_zt'})
            .then(resData => {
                if (resData.data != null) {
                    if(resData.data[0]!=null && resData.data[1]!=null && resData.data[0].VALUE=='1' && resData.data[1].VALUE=='0' ) {
                        this.setState({zt0:resData.data[1].LABEL,zt1:resData.data[0].LABEL});
                    }
                }
            })
    }

    getContent=(getContent)=>{
        this.setState({getContent:getContent});
    }

    //设置当前页面显示
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap=this.state.frameVisibleMap;
        for(let name in frameVisibleMap){
            if(name==showFlagName){
                frameVisibleMap[name]=true;
            }else{
                frameVisibleMap[name]=false;
            }
        }
        this.setState({
            frameVisibleMap:frameVisibleMap
        });
    }

    //新增按钮点击事件
    handleAddBtnClick = () => {
        this.setCurrentPageShow("addFlag");
    }

    //新增/修改分类
    handleAddOrEditFlBtnClick=()=>{
        this.setCurrentPageShow("addAndEditFlFlag");
    }

    updateSingleXxfbState=(record)=>{
        let pkid = record.PKID;
        let fbzt = record.FBZT=='1'?'0':'1';
        this.updateXxfbState([pkid],fbzt);
    }

    //单行启用禁用
    updateXxfbState = (pkids,fbzt) => {
        let userId = getLoginUser() ? getLoginUser().userId : '';
        NHFetch(baseUrlPath+"/updateXxfbState","POST",{"pkids":pkids,"fbzt":fbzt,"userId":userId,})
            .then(res => {
                if (res && res.code == 200) {
                    message.success("操作成功");
                }else{
                    message.warn("操作异常");
                }
                this.refs.nhTable.readTableData();
            });
    }

    //修改按钮点击事件
    handleUpdateBtnClick = (record) => {
        let bz=[];
        bz.push(record.FLBZ);
        if(record.FFLBZ){
            bz.push(record.FFLBZ);
        }
        record['XXFLBZ']=bz;
        this.setState({formInitData:record});
        this.setCurrentPageShow('updateFlag');
    }
    //查看按钮点击事件
    handleViewBtnClick = (record) => {
        this.setState({formInitData:record});
        this.setCurrentPageShow('showFlag');
    }
    handleCloseFrame = () => {
        this.setCurrentPageShow('tableFlag');
    }

    //单行删除
    handleSingleDeleteBtnClick = (record) => {
       NHConfirm("是否确定删除这条数据？",() => {
           let pkid = record.PKID;
           this.handleDelete([pkid]);
       },"warn");
    }
    //多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        if(selectedRowKeys && selectedRowKeys.length>0){
            NHConfirm("是否确定删除选中的多条数据？",() => {
                this.handleDelete(selectedRowKeys);
            },"warn");
        }else{
            message.warning("请先选择需要删除的数据！");
        }
    }
    //删除操作
    handleDelete = (pkids) => {
        NHFetch(baseUrlPath + '/deleteByMulti' , 'POST' , pkids)
            .then(res => {
                if (res) {
                    message.success("删除操作成功！");
                    this.refs.nhTable.filterTableData();
                }
            })
    }
    //新增面板保存方法
    handleSaveAdd = () => {
        this.refs.nhAddForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            let data = formData;
            let userId = getLoginUser() ? getLoginUser().userId : '';
            let bzArr = formData['flbz'];
            let flbz = bzArr.length>0?bzArr[bzArr.length-1]:'';
            data['flbz'] = flbz;
            data['tznr'] = this.state.getContent();
            data['yhbh'] = userId;
            NHFetch(baseUrlPath + '/insert' , 'POST' , data)
                .then(res => {
                    if (res) {
                        message.success("新增信息发布成功！");
                        this.setCurrentPageShow('tableFlag');
                        this.refs.nhTable.filterTableData();
                    }
                }).catch(err=>{
                message.success("新增异常！");
            })
        });
    }

    //修改面板保存方法
    handleSaveUpdate = () => {
        this.refs.nhUpdateForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            let data = formData;
            let arr = formData['flbz'];
            if(arr.length>0){
                data['flbz'] = arr[arr.length-1];
            }

            data['tznr'] = this.state.getContent();
            data['pkid'] = this.state.formInitData.PKID;
            NHFetch(baseUrlPath + '/update' , 'POST' , data)
                .then(res => {
                    if (res) {
                        message.success("修改信息发布成功！");
                        this.setCurrentPageShow('tableFlag');
                        this.refs.nhTable.filterTableData();
                    }
                })
        });
    }


    //单行启用禁用
    updateState = (record) => {
        let PKID = record.PKID;
        NHFetch(baseUrlPath+"/updateState","POST",{"pkid":PKID})
            .then(res => {
                if (res && res.code == 200) {
                    message.success("操作成功");
                }else{
                    message.warn("操作异常");
                }
                this.refs.nhTable.readTableData();
            });
    }

    //单行置顶
    handleZdztStateSingle = (record) => {
            let pkid = record.PKID;
            let zdzt = record.ZDZT=='1'?'0':'1';
            this.updateZdztState([pkid],zdzt);
    }

    //多行置顶
    updateZdztStateMulti = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        if(selectedRowKeys && selectedRowKeys.length>0){
            NHConfirm("是否确定置顶选中的多条数据？",() => {
                this.updateZdztState(selectedRowKeys,'1');
            },"warn");
        }else{
            message.warning("请先选择需要置顶的数据！");
        }
    }

    //单行置顶
    updateZdztState = (pkids,zdzt) => {
        NHFetch(baseUrlPath+"/updateZdztState","POST",{"pkids":pkids,"zdzt":zdzt})
            .then(res => {
                if (res && res.code == 200) {
                    message.success("操作成功");
                }else{
                    message.warn("操作异常");
                }
                this.refs.nhTable.readTableData();
            });
    }

    rowSelectionChange=(selectedRowKeys)=>{
        if (selectedRowKeys.length) {
            this.setState({
                showDeleteBtn:true,showSendBtn:true
            })
        } else {
            this.setState({
                showDeleteBtn:false,showSendBtn:false
            })
        }
    }

    render() {
        //列参数
        const columns = [
            {
                title: '序号',
                width: '70',
                dataIndex: 'ROW_ID'
            }, {
                title: '标题',
                width: '250',
                dataIndex: 'TZBT',
                render:(text,record,index)=>{
                    return (text && text.length>10)?<Tooltip title={text}>{text.substring(0,10)+"..."}</Tooltip>:text;
                },
                searchType:"input"
            }, {
                title: '分类',
                width: '200',
                dataIndex: 'FLBT',
                render:(text,record,index)=>{
                    return (text && text.length>10)?<Tooltip title={text}>{text.substring(0,10)+"..."}</Tooltip>:text;
                },
                searchType:"input"
            }, {
                title: '客户端类型',
                width: '120',
                dataIndex: 'KHDLXMC',
                searchType:"select"
            }, {
                title: '发布时间',
                width: '180',
                dataIndex: 'FBSJ',
                commonSearch: false,
                searchType:"datetime"
            }, {
                title: '发布人',
                width: '120',
                dataIndex: 'YHXM',
                searchType:"input"
            }, {
                title: '置顶时间',
                width: '180',
                dataIndex: 'ZDSJ',
                commonSearch: false,
                searchType:"datetime"
            }, {
                title: '发布状态',
                width: '110',
                dataIndex: 'FBZTMC',
                fixed:'right',
                render:(text,record,index) => {
                    const status=record.FBZT=='1'?true:false;
                    const fbztmc = ['未发布','已发布'];
                    return (
                        hasAuth('zhxg_yxgl_fwwgl_xxfb:updateFbztState')?
                            <Switch checkedChildren={fbztmc[1]} unCheckedChildren={fbztmc[0]} checked={status} onChange={() => this.updateSingleXxfbState(record)}/>:
                            <span>{status?fbztmc[1]:fbztmc[0]}</span>
                    );
                },
                searchType:"select"
            }, {
                title: '置顶状态',
                width: '100',
                dataIndex: 'ZDZTMC',
                fixed:'right',
                render:(text,record,index) => {
                    const status=record.ZDZT=='1'?true:false;
                    const zdztmc = ['未置顶','已置顶'];
                    return (
                        hasAuth('zhxg_yxgl_fwwgl_xxfb:updateZdztState')?
                            <Switch checkedChildren={zdztmc[1]} unCheckedChildren={zdztmc[0]} checked={status} onChange={() => this.handleZdztStateSingle(record)}/>:
                            <span>{status?zdztmc[1]:zdztmc[0]}</span>
                    );
                },
                searchType:"select"
            }
        ];
        //行内操作
        const action = [
            {title:'查看',onClick:this.handleViewBtnClick,auth:'zhxg_yxgl_fwwgl_xxfb:view'},
            {title:'修改',onClick:this.handleUpdateBtnClick,auth:'zhxg_yxgl_fwwgl_xxfb:udpate'},
            {title:'删除',onClick:this.handleSingleDeleteBtnClick,auth:'zhxg_yxgl_fwwgl_xxfb:multiple_delete'},
        ];
        return (
            <div className={css.main_right_content} style={{height:getSize().windowH-163}}>
                <div className={css.table} style={{display:this.state.frameVisibleMap.tableFlag?'block':'none'}}>
                    <NHTable ref='nhTable'
                             rowKey={record =>record.PKID}
                             sign={"zhxg_yxxt_fwwgl_xxfb_queryPage"}
                             columns={columns}
                             action={action}
                             rowSelectionChange={this.rowSelectionChange}
                    >
                        {hasAuth('zhxg_yxgl_fwwgl_xxfb:add')?<Button type="primary" onClick={this.handleAddBtnClick}>新增</Button>:null}
                        {hasAuth('zhxg_yxgl_fwwgl_xxfb:operateFl')?<Button type="primary" ghost style={{marginLeft:10}} onClick={this.handleAddOrEditFlBtnClick}>信息分类</Button>:null}
                        {hasAuth('zhxg_yxgl_fwwgl_xxfb:updateZdztStateMulti')?<Button type="primary" ghost style={{marginLeft:10}} onClick={this.updateZdztStateMulti}>信息置顶</Button>:null}
                        {hasAuth('zhxg_yxgl_fwwgl_xxfb:delete')?<Button type="danger" ghost style={{marginLeft:10,display:this.state.showDeleteBtn?undefined:'none'}}
                                                                        onClick={this.handleMultiDeleteBtnClick}>删除</Button>:null}
                    </NHTable>
                </div>
                <NHContainerFrame ref="nhAddModal"
                         title="新增信息发布"
                         visible={this.state.frameVisibleMap.addFlag}
                         onOk={this.handleSaveAdd}
                         onCancel={this.handleCloseFrame}
                >
                    <EditForm ref="nhAddForm" getContent={this.getContent} />
                </NHContainerFrame>
                <NHContainerFrame ref="nhUpdateModal"
                         title="修改信息发布"
                         visible={this.state.frameVisibleMap.updateFlag}
                         onOk={this.handleSaveUpdate}
                         onCancel={this.handleCloseFrame}
                >
                    <EditForm ref="nhUpdateForm" getContent={this.getContent}  initFormData={this.state.formInitData}/>
                </NHContainerFrame>
                <NHContainerFrame ref="nhShowModal"
                         visible={this.state.frameVisibleMap.showFlag}
                         title="查看信息发布"
                         footer={null}
                         onCancel={this.handleCloseFrame}
                >
                    <ViewForm initFormData={this.state.formInitData} zt0={this.state.zt0} zt1={this.state.zt1} />
                </NHContainerFrame>
                <NHContainerFrame ref="nhShowModal"
                                  visible={this.state.frameVisibleMap.addAndEditFlFlag}
                                  title="信息分类"
                                  footer={null}
                                  onCancel={this.handleCloseFrame}
                >
                    <EditFlForm zt0={this.state.zt0} zt1={this.state.zt1}/>
                </NHContainerFrame>
            </div>
        );
    }
}
export default XxfbTab;



// WEBPACK FOOTER //
// ./components/fwwgl/xxfb/XxfbTab.js